/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_DonateInputs */

const en_footer_action_donate = /** @type {(inputs: Footer_Action_DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate`)
};

/**
* | output |
* | --- |
* | "Donate" |
*
* @param {Footer_Action_DonateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_donate = /** @type {((inputs?: Footer_Action_DonateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_DonateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_donate(inputs)
});